<template>
  <div
    class="cmp-pro-agency-data-transfer dbox"
    style="margin:40px;"
  >
    <div class="top-bar">
            <div class="logo">
                <img class="company-logo"
                   width="99"
                   height="30"
                    :src="`https://detailss3web.s3.amazonaws.com/images/logo/detailslogo`"
                    alt 
                />
            
                <img class="arrow"
                   width="30"
                   height="30"
                   src="static/icons/arrows/arrow-right.svg"
                    alt 
                />
                <img class="arrow"
                   width="75"
                   height="30"
                   src="static/icons//pro_agency_logo.png"
                    alt 
                />
                 <!-- <button class="dt-button v1 s5" @click="refresh">Login P.R.O Agency</button> -->
            </div>
            <div class="buton-group">
                <button v-if="!exportClick" style="margin-right:10px" class="dt-button v1 h22p" @click="refresh">Refresh</button>
            <!-- https://dev.berlin3.com/updatecheck/label.pl?section=plugin&action=pro_agency_export_data_from_interface&product_ids=&api_account=details&label_ids=3&label_filter_id=3&start=2016-01-01&end=2021-01-31&limit=25  -->
                <button style="margin-right:10px" class="dt-button v1 h22p" @click="exportData">Export</button>
                <button v-if="!exportClick" class="dt-button v1 h22p" @click="transferData">Transfer Data to PRO. Agency</button>
                 <!-- <button v-if="exportClick" class="dt-button v1 h22p" @click="goToProAgency">Go to PRO. Agency</button> -->
            </div>
      
    </div>
    <NTable
      id="contacts-contacts-contact_sidewindow-invoice_list"
      class="h1"
      :headers="headers"
      :items="items"
      :config="proAgencyTableConfig"
      :loadingFlag="isLoading"
    >
      <template v-slot:thead="{ thcon, thtext }">
        <tr>
          <th
            v-for="header in headers"
            v-bind="thcon(header.value)"
            :key="header.value"
          >
            <div v-if="header.value=='chk'"  class="header-name">
               <div class="minus-parent" :class="{
                 'selected': selectAllNone,
               }" @click="onCheckboxChangeAll" >
                  <div class="minus-child">
                  </div>
                
               </div>
            </div>
            <div v-else-if="header.value=='exclude_for_label'" style="margin-top:10px;display:flex" class="header-name">
              <div>{{thtext(header.value)}}</div>
              <div style="margin-top:-4px">
                  <img class="arrow"
                      width="30"
                      height="30"
                    src="static/icons/question.svg"
                      alt 
                  />
              </div>
            </div>
            <div v-else class="header-name">
              {{thtext(header.value)}}
            </div>

          </th>
        </tr>
      </template>
      <template v-slot:item="{ item, tdcon }">
        <tr>
             <td v-if="!exportClick" v-bind="tdcon('chk')">
               <div class="checkbox-container">
                  <div class="dt-checkbox v2 s1">
                    <input
                      type="checkbox"
                      name="name"
                      
                      :checked="selectedProducts.has(item.product_id)"
                       @click="e => onCheckboxChange(e, 'name', item)"
                    />
                    <div class="checkmark"></div>
                  </div>
                </div>
            </td>
            <td v-bind="tdcon('label')">
                <span >{{item['LabelName']}}</span>
            </td>
            
            <td v-bind="tdcon('Cat No.')">
                <span >{{item['CatalogueNumber']}}</span>
            </td>
   
            <td v-bind="tdcon('artists')">
                <span >{{item['ReleaseArtist']}}</span>
            </td>
            <td v-bind="tdcon('title-scc')">
                <span >{{item['ReleaseTitle']}}</span>
            </td>
            
            
            <td v-bind="tdcon('costs_format')">
                        <span >{{item['Format']}}</span>
                    </td>
            
            <td v-bind="tdcon('UPC / EAN')">
                        <span >{{item['UPC / EAN']}}</span>
                    </td>
            
            <td v-bind="tdcon('release_date')">
                <span >{{item['ReleaseDate']}}</span>
            </td>
            <td v-bind="tdcon('tab_title_tracks')">
                  <span style="">{{item['TrackCount']}}</span>
            </td>
            
            <td v-if="!exportClick" v-bind="tdcon('sales_import_suspend')">
                <span style="text-align:center">{{item['Error_Count']}}</span>
            </td>
            <td v-if="!exportClick" v-bind="tdcon('Errors Description')">
                <span >{{item['Errors']}}</span>
            </td>
            <td v-if="!exportClick" v-bind="tdcon('exclude_for_label')">
              <div style="text-align:right"> 
                <img class="dt-icon s2"
                
                @click="omitProduct(item['product_id'])"
                  
                    src="static/icons/omit-accent.svg"
                      alt 
                  />
              </div>
            </td>

            <td v-if="exportClick" v-bind="tdcon('response')">
              <template v-if="item['response']=='yes'">
                <div   style="text-align:center;background-color:#4FE890;border-radius:50px;max-width:40px">Yes</div>
              </template>
              <template v-else>
                <v-menu
                      :close-on-content-click="false"
                      open-on-hover
                      :nudge-right="40"
                      lazy
                      left
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      class="cmp-pro-agency-data-transfer---popup-container"       
                            
                    >
                      <span slot="activator">
                        <div style="color:#FF6E6E">
                          {{item['response']}}
                        </div>
                      </span>
                      <div class="cmp-pro-agency-data-transfer--popup">
                        <div class="cmp-pro-agency-data-transfer--popup-content">
                            {{item['response']}}
                        </div>
                      </div>
                </v-menu>
              </template>
            </td>

            <td v-if="exportClick " v-bind="tdcon('error-list-icon')">
               
                <v-menu
                    :close-on-content-click="false"
                    open-on-hover
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    left
                    full-width
                    max-width="290px"
                    class="cmp-pro-agency-data-transfer---popup-container"       
                     v-if="item['response']!='yes'"      
                  >
                    <span slot="activator">
                      <div>
                       <img
                        @click="errorList"
                        v-if="item['response']!='yes'"
                        :src="imgsrc"
                        class="dt-icon v5 s2"
                        style="border-radius:0px"
                        @mouseover="
                          (e) => onHover(e)
                        "
                        @mouseleave="
                          (e) => onLeave(e)
                        "
                    
                       />
                      </div>
                    </span>
                    <div class="cmp-pro-agency-data-transfer--popup">
                      <div class="cmp-pro-agency-data-transfer--popup-content">
                          Overview Error Code
                      </div>
                    </div>
              </v-menu>
                    
            </td>
          
   
        </tr>
      
      </template>
    </NTable>

   
    <!-- {{[...selectedProducts]}} -->
      
      <v-dialog v-model="deleteModal" persistent width="390">
        <Modal :id="'cmp-add-group'" @cancelled="onCancelClick">
          <template slot="header">
            <v-layout row wrap mx-1>Warning</v-layout>
          </template>
          <template slot="body">
            <p>On confirmation, this product will not be suggested for delivery to P.R.O. Agency again.</p>
          </template>
          <template slot="options">
            <button 
              class="dt-button" 
              @click.stop="onCancelClick"
            > {{$t('cancel')}} 
            </button>
            <button
              class="dt-button v1"
              @click.stop="onConfirmOmit"
            >
                    {{$t('OK')}}
            
            </button>
          
        </template>
        </Modal>
      </v-dialog>
  </div>
</template>

<script>

import NTable from "../../../plugins/datatable/datatable";
import Modal from "../../../dt-plugins/modal/modal";

import {
  createNTableConfig,
  createTableHeader,
} from "../../../plugins/datatable";
import {ProAgencyService} from "../../../services/pro-agency-data-transfer-service"
import { clientName } from "../../../services/http/http-client";
import { getBaseUrl } from "../../../services/http/http-client";
import { LABEL_URL } from "../../../services/common-urls";
import { ConfirmationService } from '../../../dt-plugins/confirmation/confirmation.service';
import { addRemoveSet } from '../../../utility';
import * as I18nActionTypes from "../../../store/app/i18n/types";

export default {
  components: {
      NTable,
      Modal,
  },
  props: {
    
  },
  data: function () {
   return {
    proAgencyTableConfig: createNTableConfig({
        headerStyle: 1,
        rowHeight: 48,
        fullHeight: true,
    }),
    proAgencyData:[{LabelName:""}],
    clientName: clientName,
    deleteModal: false,
    selectedProducts: new Set(),
    omitConfirm: false,

    exportClick: false,
    responseAgencyData:[{LabelName:""}],
    selectAllNone: false,
    imgsrc: 'static/icons/error-list.svg',
    isLoading: true,
   };
  },
  mounted:async function(){
    console.log('Mounted Call');
    this.isLoading=true;

    this.$store.dispatch(
      I18nActionTypes.UPDATE_SYSTEM_LANGUAGE,
      {
        locale: 'en',
        language: 'English'
      },
    );
    console.log("agencyRes Fetch");
      const agencyRes = await ProAgencyService.getProAgencyData(this.api_account,
        this.label_ids,
        this.label_filter_id,
        this.start,
        this.end,
        this.limit
      );
      
      this.proAgencyData=agencyRes.data.data.products;
      this.proAgencyData.forEach(element => {
          if(!element.Errors){
            this.selectedProducts.add(element.product_id)
          }
      });
      // setTimeout(() => {
      //   // this.isLoading=false
      // }, 3000);
      this.isLoading=false;
      console.log("agency Fetch Done",this.proAgencyData) ;
  },
  computed: {
    proAgencyHeaders: function () {
      return [        
        createTableHeader("chk",{text:false,mw:30}),
        createTableHeader("label",{f:0.25}),
        createTableHeader("Cat No.",{f:0.2}),
        createTableHeader("artists",{f:0.2}),
        createTableHeader("title-scc",{text:this.$t('Title'),f:0.3}),
        createTableHeader("costs_format",{f:0.2}),
        createTableHeader("UPC / EAN",{f:0.2}),
        createTableHeader("release_date",{f:0.2}),
        createTableHeader("tab_title_tracks",{f:0.1}),
        createTableHeader("sales_import_suspend",{f:0.1}),
        createTableHeader("Errors Description",{f:0.3}),
        createTableHeader("exclude_for_label",{mw:80}),
      ];
    },
    proAgencyResponseHeaders: function () {
      return [        
        createTableHeader("label",{f:0.1}),
        createTableHeader("Cat No.",{f:0.1}),
        createTableHeader("artists",{f:0.1}),
        createTableHeader("title-scc",{text:this.$t('Title'),f:0.2}),
        createTableHeader("costs_format",{f:0.15}),
        createTableHeader("UPC / EAN",{f:0.1}),
        createTableHeader("release_date",{f:0.1}),
        createTableHeader("tab_title_tracks",{f:0.05}),
        createTableHeader("response",{text:"Response",f:0.25}),
        createTableHeader("error-list-icon",{text:false ,mw:40}),
      ];
    },
    headers: function() {
      console.log('headers', this.proAgencyHeaders, this.proAgencyResponseHeaders);
      return this.exportClick ? this.proAgencyResponseHeaders : this.proAgencyHeaders;
    },
    // isloading:function(){
    //   return this.items.length>0?false:true
    // },
    items: function() {
      return this.exportClick ? this.responseAgencyData : this.proAgencyData;
    },
    api_account:function(){
      return this.$route.query.api_account//||''//'details';
    },
    label_ids:function(){
      return this.$route.query.label_ids//||''//'3';
    },
    label_filter_id:function(){
      return this.$route.query.label_filter_id//||''//'3';
    },
    start:function(){
      return this.$route.query.start//||''//'2016-01-01';
    },
    end:function(){
      return this.$route.query.end//||''//'2021-02-01';
    },
    limit:function(){
      return this.$route.query.limit//||''//'25';
    },
    product_ids:function(){
      console.log("RESPONSE")
      if(this.items){
            return this.items.map(e=>{
          return e.product_id
        })
      }
      else{
        return ""
      }
      
   
    }
  },
  methods: {
    onHover:function(e){
      console.log('e',e.target.src)
      e.target.src='static/icons/error-list-hover.svg'
    },
    onLeave:function(e){
        e.target.src='static/icons/error-list.svg'
    },
    onCheckboxChangeAll:function(e){
     
     // console.log(checked);
      if ( !this.selectAllNone) {
         this.selectAllNone = true;
         //console.log("PROAGENCY DATA",thi)
         this.selectedProducts = new Set(this.proAgencyData.map(e => e.product_id));
       
      } else {
        this.selectAllNone = false;
        this.selectedProducts = new Set();
      }
    },
    refresh:function(){
      location.reload();
    },
    errorList:function(){
        window.open("https://details.zendesk.com/hc/en-us/articles/360018321238",'_blank')
    },
    exportData:async function(){
      let url=`${getBaseUrl()}${LABEL_URL}?section=plugin&action=pro_agency_export_data_from_interface&`+
      `api_account=${this.api_account}`+
      `&label_ids=${this.label_ids}`+
      `&label_filter_id=${this.label_filter_id}`+
      `&start=${this.start}`+
      `&end=${this.end}`+
      `&limit=${this.limit}`
      if(this.exportClick){
        url=`${getBaseUrl()}${LABEL_URL}?section=plugin&action=pro_agency_export_data_from_interface&`+
        `product_ids=${this.product_ids.join()}&`+
        `api_account=${this.api_account}`+
        `&label_ids=${this.label_ids}`+
        `&label_filter_id=${this.label_filter_id}`+
        `&start=${this.start}`+
        `&end=${this.end}`+
        `&limit=${this.limit}`
      }
 
      console.log("WWW",url)
      window.open(url);
  
    },
    onCheckboxChange: function(event, name, item) {
      const value = event.target.checked;
       this.selectedProducts = addRemoveSet(
        event.target.checked,
        this.selectedProducts,
        item.product_id
      );
      console.log("WWWW",this.selectedProducts,item);
    },
    omitProduct:async function(id){
      console.log("HIDDEN ID",id);
      this.deleteModal=true
      if(this.omitConfirm){
        ProAgencyService.omitProduct(id)
        this.omitConfirm=false
        this.deleteModal=false
      }
      
    },
    onCancelClick:function(){
      this.deleteModal=false
    },
    transferData:async function(){
      console.log("P",)
      const products=[...this.selectedProducts]
      const transferRes=await ProAgencyService.transferProAgencyData(JSON.stringify(products),this.api_account)
     
      const resProduct=await ProAgencyService.resultProAgencyData(transferRes.data.product_ids.join())
      console.log("DATA",products,transferRes.data.product_ids,resProduct.data.data.products)


      this.responseAgencyData=resProduct.data.data.products;
      this.exportClick=true;

      // this.$router.push({
      //   path:'/main/transfer-response',
      //   query: {
      //     api_account:this.api_account,
      //     label_ids:this.label_ids,
      //     label_filter_id:this.label_filter_id,
      //     start:this.start,
      //     end:this.end,
      //     limit:this.end,
      //     resProduct: resProduct.data.data.products
      //   }
      // });
    },
    onConfirmOmit:function(){
      this.omitConfirm=true;
    },
       goToProAgency:function(){
      const url="https://prodb.pro-agency.net/login?LoginRequired"

      window.open(url)
    },
  },
};

</script>

<style lang="scss" scoped>
  .cmp-pro-agency-data-transfer{


    .dt-ntable tbody.dt-loading tr:before {
      // background:#282828;
    } 
   .top-bar{
      display: flex;
      .logo{
        flex:3
      }
      .buton-group{
        display: flex;
        button{
          border-color: #0087ff;
          color:#0087ff;
          background: transparent;
        }
      }
    }
    .minus-parent{
        padding:4px;
        background-color:white;
        border-radius:2px;
        display:flex;
        width:12px;
        justify-content:center;
        border:1px solid #000;
        cursor: pointer;

        &.selected {
          background-color:black;
        }
    }
    .minus-child{
       height:2px;
       background-color:white;
       flex:1;
       min-width:6px
    }
  }
  .cmp-pro-agency-data-transfer--popup {     
      // position: relative;
    
      // float: left;
      
      // &:before  {
      //   content: " ";
      //   position: absolute;
      
      //   top: -15px;
      //   border-bottom: 15px solid black;
      //   border-right: 15px solid transparent;
      //   border-left: 15px solid transparent;
      //   border-top: none;
      // }
      .cmp-pro-agency-data-transfer--popup-content {
        background-color: #282828;
        color: #fff;
        padding: 10px;
        border-radius: 10px;
    

       
      }
    }
  .cmp-pro-agency-data-transfer---popup-container {
    
    
  }
</style>


<style scoped>
  .menu__content {
    border: none !important;
    box-shadow: none !important;
  }
</style>